import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ButtonHudNormal } from "../generic/common/ButtonHudNormal";
import { Icon } from "../generic/icon/Icon";
import { TextLoca } from "../generic/text/TextLoca";
export var CoopSearchLanguageFilter = React.memo(function (_a) {
    var onFilterMenuClick = _a.onFilterMenuClick, languageIcon = _a.languageIcon;
    return (React.createElement("div", { className: "flex flex--aligned flex--end " + IdStyles.CoopSearchContainer + " coop-search-lang-container" },
        React.createElement(TextLoca, { id: IdLoca.coopLanguage_title, className: "coop-search-lang-title" }),
        React.createElement(ButtonHudNormal, { onClick: onFilterMenuClick, className: "flex flex--guts" },
            React.createElement(Icon, { icon: languageIcon, styleId: IdStyles.IconMedium }))));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/CoopSearchLanguageFilter.tsx
// module id = 2623
// module chunks = 3